import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useWatch } from 'react-hook-form';

import { useReservationsConfig } from 'reservations/account/providers/ConfigProvider';
import getTimeSlotSpan from 'reservations/availabilities/helpers/getTimeSlotSpan';
import type { Slot } from 'reservations/availabilities/types';

type BaseTimeSlotsProps = {
  handleSlotClick: (_timeSlot: string) => void;
  name: string;
  slots: (Slot | null)[];
};

const BaseTimeSlots = ({
  slots,
  handleSlotClick,
  name
}: BaseTimeSlotsProps) => {
  const { slotSize } = useReservationsConfig();
  const date = useWatch({
    name: 'date'
  });
  const timeSlotSpan = getTimeSlotSpan(slotSize);

  return (
    <>
      {slots.map((slot, index) => {
        const key = `${date}-${slot?.time12 ?? null}-${slotSize}-${index}`;

        if (!slot) {
          return (
            <Grid item key={key} xs={timeSlotSpan}>
              <Button
                aria-label="unavailable"
                disabled
                variant="contained"
                size="fullWidth"
              />
            </Grid>
          );
        }

        const { time12, status } = slot;
        const formattedTime = time12.replace(' ', '');
        const isDisabled = status === 0;

        return (
          <Grid item key={key} xs={timeSlotSpan}>
            <Button
              disabled={isDisabled}
              name={name}
              onClick={() => handleSlotClick(time12)}
              variant="contained"
              size="fullWidth"
            >
              {formattedTime}
            </Button>
          </Grid>
        );
      })}
    </>
  );
};

export default BaseTimeSlots;
